<template>
    <header class="head-wrap">
        <router-link class="head-link" to="/about">关于本人</router-link>
        <a href="#/" class="head-logo">
            <span class="head-logo-bg"></span>
            <span class="head-text">AJUAN</span>
        </a>
        <router-link class="head-link" to="/novel">随便写写</router-link>
    </header>
</template>
<script>
    export default {

    }
</script>
<style lang="scss">
    @import '../assets/scss/define';
    .head-wrap{
        @extend %w100;
        @extend %df;
        @extend %oh;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        height: 58px;
        z-index: 1;
        box-shadow: 0 0 50px rgba(0,0,0,0.8);
    }
    .head-link{
        @extend %f14;
        @extend %c3;
        &.router-link-active{
            color: #000;
            border-bottom: 2px solid #000;
        }
    }
    .head-logo{
        @extend %h100;
        @extend %pr;
        @extend %df;
        justify-content: center;
        align-items: center;
        margin: 0 100px;
    }
    .head-text{
        @extend %cfff;
        @extend %fwb;
        @extend %f18;
        @extend %pr;
    }
    .head-logo-bg{
        @extend %pa;
        @extend %t50;
        @extend %l50;
        @include tft(rotate(45deg));
        background-color: #000;
        margin-left: -50px;
        margin-top: -50px;
        width: 100px;
        height: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/components/head-wrap.vue